import React from 'react';
import { Star, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-primary text-white overflow-hidden" data-id="element-71">
      {/* Urgency Bar */}
      <div className="bg-brand-dark text-center py-2.5 px-4 text-sm font-semibold flex items-center justify-center gap-2" data-id="element-72">
        <span data-id="element-73">⏰</span>
        <span data-id="element-74">
          Oferta de lanzamiento: $16 por tiempo limitado — Acceso inmediato
        </span>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 text-center" data-id="element-75">
        <div className="max-w-3xl mx-auto" data-id="element-76">
          <div className="flex justify-center mb-6" data-id="element-77">
            <span className="inline-flex items-center gap-2 bg-brand-accent text-brand-dark text-xs sm:text-sm font-extrabold uppercase tracking-wide px-4 py-2 rounded-full shadow-lg ring-2 ring-white/30" data-id="element-78">
              <span aria-hidden="true" data-id="element-79">✨</span>
              Método nutricional validado
            </span>
          </div>

          {/* Trust Badge */}
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-80">
            <div className="flex text-yellow-400" data-id="element-81">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-82" />)}
            </div>
            <span className="text-brand-bg/90 text-sm font-medium" data-id="element-83">
              4.9/5 (Más de 2,000 clientes felices)
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-84">
            Recetas Deliciosas para{' '}
            <span className="text-brand-accent" data-id="element-85">Hígados Sanos</span>
          </h1>

          <div className="mb-10 rounded-2xl overflow-hidden shadow-2xl ring-4 ring-white/10" data-id="element-86">
            <img src="https://cdn.magicpatterns.com/uploads/sv4PPPdd8k5sXGYK6SGgV6/nutricion_hook.webp" alt="Collage de recetas saludables y deliciosas para apoyar el bienestar de tu hígado: platos balanceados, snacks y postres ligeros." className="w-full h-auto object-cover" width={1024} height={600} loading="eager" fetchPriority="high" decoding="async" data-id="element-87" />
          </div>

          <p className="text-lg md:text-xl text-brand-bg/90 mb-10 leading-relaxed" data-id="element-88">
            Come rico, cuida tu hígado y recupera tu energía — sin dietas
            aburridas ni sacrificios imposibles.
          </p>

          <div className="flex flex-col items-center justify-center gap-3" data-id="element-89">
            <a href="https://noveliahub.com/cart/50878318477348:1" className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-4 px-8 rounded-full shadow-[0_8px_30px_rgba(249,115,22,0.5)] transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-400/60" data-id="element-90">
              Quiero mis recetas ahora
            </a>
            <p className="text-sm font-semibold text-white" data-id="element-91">
              Solo $16 — Acceso inmediato
            </p>
          </div>

          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-brand-bg/80" data-id="element-92">
            <ShieldCheck className="w-5 h-5 text-brand-accent" data-id="element-93" />
            <span data-id="element-94">Garantía de devolución de 60 días. Compra 100% segura.</span>
          </div>
        </div>
      </div>

      {/* Decorative bottom curve */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-brand-bg" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 0 100%)'
    }} data-id="element-95"></div>
    </section>;
}